<template>
  <credit-widget class="risk-insights" data-testid="risk-insights-widget">
    <template #widget-header>
      <i-icon
        class="icon i-text-neutral-110"
        symbol="small-alert-circle"
        :size="16"
      ></i-icon>
      <span>Risk Insights</span>
    </template>
    <template #widget-content>
      <div class="line">
        <span>Count of NSFs</span>
        <credit-widget-value :value="nfsCount"></credit-widget-value>
      </div>
      <div class="line">
        <span>Count of Overdrafts</span>
        <credit-widget-value
          :currency="false"
          :value="overdraftsCount"
        ></credit-widget-value>
      </div>
      <div class="line">
        <span>Count of NSF Days</span>
        <credit-widget-value :value="nfsDays"></credit-widget-value>
      </div>
      <div class="line">
        <span>Total Gambling Spend</span>
        <credit-widget-value
          :currency="true"
          :value="totalGambling"
        ></credit-widget-value>
      </div>
      <div class="line">
        <span>Count of Negative Balance Days</span>
        <credit-widget-value
          :currency="false"
          :value="countOfNegativeBalanceDays"
        ></credit-widget-value>
      </div>
    </template>
  </credit-widget>
</template>

<script>
import { mapState } from 'vuex';
import CreditWidget from '@/V2/credit/widgets/CreditWidget';
import CreditWidgetValue from '@/V2/credit/widgets/CreditWidgetValue';
import { iIcon } from '@inscribe/signal';

export default {
  name: 'RiskInsights',
  components: { CreditWidget, CreditWidgetValue, iIcon },
  computed: {
    ...mapState({
      credit: 'credit',
    }),
    nfsDays() {
      return this.credit?.customerRisk?.count_nsf_days;
    },
    nfsCount() {
      return this.credit?.customerRisk?.count_nsf;
    },
    overdraftsCount() {
      return this.credit?.customerRisk?.count_overdraft;
    },
    totalGambling() {
      return this.credit?.customerRisk?.total_gambling_spend;
    },
    countOfNegativeBalanceDays() {
      return this.credit?.customerRisk?.count_negative_balance_days;
    },
  },
};
</script>
